import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Image, Spinner, Alert } from 'react-bootstrap';
import fabricService from '../../services/fabricService';
import config from '../../config';

const FabricSinglePage = () => {
  const { id } = useParams();
  const [fabric, setFabric] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadFabricDetails();
  }, [id]);

  const loadFabricDetails = async () => {
    try {
      setLoading(true);
      const data = await fabricService.getFabricById(id);
      setFabric(data.fabric);
      setPhotos(data.photos || []);
    } catch (error) {
      console.error('Failed to load fabric details:', error);
      setError('Failed to load fabric details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', padding: '40px 0' }}>
        <Container>
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '60vh', padding: '40px 0' }}>
        <Container>
          <Alert variant="danger">{error}</Alert>
        </Container>
      </div>
    );
  }

  if (!fabric) {
    return (
      <div style={{ minHeight: '60vh', padding: '40px 0' }}>
        <Container>
          <Alert variant="warning">Kumaş bulunamadı</Alert>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '60vh', padding: '40px 0' }}>
      <Container>
        <Row>
          <Col md={6}>
            {fabric.main_image && (
              <Image 
                src={(() => {
                  // Eğer path zaten /api ile başlıyorsa, sadece domain ekle
                  if (fabric.main_image.startsWith('/api/')) {
                    return `https://tekstas.com${fabric.main_image}`;
                  }
                  // Eğer path /uploads ile başlıyorsa, API_URL ile birleştir
                  else if (fabric.main_image.startsWith('/uploads/')) {
                    return `${config.API_URL}${fabric.main_image}`;
                  }
                  // Diğer durumlar için API_URL ile birleştir
                  else {
                    return `${config.API_URL}${fabric.main_image}`;
                  }
                })()}
                alt={fabric.name}
                fluid
                className="mb-4"
                style={{ borderRadius: '8px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
          </Col>
          <Col md={6}>
            <h1 className="mb-3">{fabric.name}</h1>
            <p className="lead mb-4">{fabric.description}</p>
            <p className="text-muted">
              Eklenme tarihi: {new Date(fabric.created_at).toLocaleDateString('tr-TR')}
            </p>
          </Col>
        </Row>

        {photos.length > 0 && (
          <div className="mt-5">
            <h3 className="mb-4">Galeri</h3>
            <Row>
              {photos.map((photo) => (
                <Col md={4} key={photo.id} className="mb-4">
                  <Image 
                    src={(() => {
                      // Eğer path zaten /api ile başlıyorsa, sadece domain ekle
                      if (photo.image_path.startsWith('/api/')) {
                        return `https://tekstas.com${photo.image_path}`;
                      }
                      // Eğer path /uploads ile başlıyorsa, API_URL ile birleştir
                      else if (photo.image_path.startsWith('/uploads/')) {
                        return `${config.API_URL}${photo.image_path}`;
                      }
                      // Diğer durumlar için API_URL ile birleştir
                      else {
                        return `${config.API_URL}${photo.image_path}`;
                      }
                    })()}
                    alt={`${fabric.name} - Fotoğraf ${photo.id}`}
                    fluid
                    style={{ borderRadius: '8px', cursor: 'pointer' }}
                    onClick={() => window.open((() => {
                      if (photo.image_path.startsWith('/api/')) {
                        return `https://tekstas.com${photo.image_path}`;
                      }
                      else if (photo.image_path.startsWith('/uploads/')) {
                        return `${config.API_URL}${photo.image_path}`;
                      }
                      else {
                        return `${config.API_URL}${photo.image_path}`;
                      }
                    })(), '_blank')}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
};

export default FabricSinglePage; 